import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSlice: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSlice"><Path d="M5.75017 2.68945L1.68945 6.75017L6.93085 11.9905L3.73735 15.0829L4.27454 15.6218C7.42322 18.7807 10.1244 20.3147 12.8958 20.8107C15.6402 21.3019 18.3517 20.752 21.433 19.9775L22.7158 19.6551L5.75017 2.68945Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSlice;
